import { Skeleton } from '@/components/ui/skeleton';

export function LotSizingHeaderSkeleton() {
  return <Skeleton className='h-8 w-60' />;
}
